export function selectFlows() {
    return (state) => state.flows.current;
}